import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import axios from "../../api/axios";
import { defaultLanguage } from "../../constants";
import facebookIcon from "../../assets/social/Facebook.png";
import instaIcon from "../../assets/social/Instagram.png";
import linkedinIcon from "../../assets/social/Linkedin (1).png";
import youtubeIcon from "../../assets/social/Youtube.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const WEBSITE_URL = "/contact";

const FooterContactInfo = () => {
  const art = defaultLanguage;
  const title = "contact";
  const { username } = useAuth();

  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [number, setNumber] = useState(-1);
  const [zip, setZip] = useState(-1);
  const [tel, setTel] = useState("");
  const [mail, setMail] = useState("");
  const [fb, setFb] = useState("");
  const [ig, setIg] = useState("");
  const [ln, setLn] = useState("");
  const [yt, setYt] = useState("");

  const formatAddressURL = (street, number, zip, city) => {
    return (
      "https://maps.google.com/?q=" +
      encodeURIComponent(`${street} ${number} ${zip} ${city}`)
    );
  };

  useEffect(() => {
    const getContent = async () => {
      await axios
        .get(`${WEBSITE_URL}`, {
          params: { username, art, title },
        })
        .then((res) => {
          setStreet(res?.data?.entry?.street);
          setCity(res?.data?.entry?.city);
          setNumber(res?.data?.entry?.number);
          setZip(res?.data?.entry?.zip);
          setCountry(res?.data?.entry?.country);
          setTel(res?.data?.entry?.tel);
          setMail(res?.data?.entry?.mail);
          setFb(res?.data?.entry?.fb);
          setIg(res?.data?.entry?.ig);
          setLn(res?.data?.entry?.ln);
          setYt(res?.data?.entry?.yt);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getContent();
  }, [username, art, title]);

  return (
    <div className="footer-column">
      <h2>About</h2>

      {tel && (
        <li>
          <span className="footer-nav">
            <FontAwesomeIcon icon={faPhone} style={{ marginRight: "8px" }} />
            {tel}
          </span>
        </li>
      )}

      {mail && (
        <li>
          <span className="footer-nav">
            <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: "8px" }} />
            {mail}
          </span>
        </li>
      )}

      {(street || number || zip || city || country) && (
        <li
          className="footer-nav"
          style={{
            display: "flex",
            alignItems: "flex-start",
            paddingTop: "2px",
            lineHeight: "1.4",
          }}
        >
          <FontAwesomeIcon
            icon={faLocationDot}
            style={{ marginRight: "8px", paddingTop: "4px" }}
          />
          <a
            href={formatAddressURL(street, number, zip, city)}
            target="_blank"
            rel="noopener noreferrer"
            className="link-reset clean-location"
          >
            {`${street} ${number}, ${zip} ${city}, ${country}`}
          </a>
        </li>
      )}

      <div className="social-icons">
        {fb && (
          <a className="social-icon" href={fb} target="_blank" rel="noreferrer">
            <img src={facebookIcon} alt="Facebook" />
          </a>
        )}
        {ig && (
          <a className="social-icon" href={ig} target="_blank" rel="noreferrer">
            <img src={instaIcon} alt="Instagram" />
          </a>
        )}
        {ln && (
          <a className="social-icon" href={ln} target="_blank" rel="noreferrer">
            <img src={linkedinIcon} alt="LinkedIn" />
          </a>
        )}
        {yt && (
          <a className="social-icon" href={yt} target="_blank" rel="noreferrer">
            <img src={youtubeIcon} alt="YouTube" />
          </a>
        )}
      </div>
    </div>
  );
};
export default FooterContactInfo;
